// 261010 P8b-2 — timeline Ghép ngang cả tập. Nhận `status.events` nguyên. Không poster, không "đã duyệt".
import React from 'react';
import type { WorkflowEventStatus } from '../../types/filmWorkflow';
import { timelineOf } from './workflowTimelineUtils';

interface Props {
  events: WorkflowEventStatus[];
  onOpen: (eventId: string) => void;
}

const WorkflowAssemblyTimeline: React.FC<Props> = ({ events, onOpen }) => {
  const t = timelineOf(events);
  if (t.total === 0) return null;
  return (
    <div className="wf-tl-card" data-testid="wf-assembly-timeline">
      <div className="wf-tl-head">
        <span>{t.summary}</span>
      </div>
      <div className="wf-tl" role="list" aria-label="Dải clip theo thứ tự phim">
        {t.groups.map((g) => (
          <div key={g.sceneId} className="wf-tl-sc" role="listitem">
            <span className="wf-tl-lab">Cảnh {g.sceneOrder}</span>
            <div className="wf-tl-row">
              {g.cells.map((c) => (
                <button
                  key={c.eventId} type="button" className={`wf-tl-it ${c.kind}`}
                  onClick={() => onOpen(c.eventId)}
                  aria-label={`Video ${c.eventOrder}, ${c.label}, mở bước Video`}
                >
                  <div className="wf-tl-box" style={{ width: c.widthPx }}><span>{c.clock}</span></div>
                  <b>Video {c.eventOrder}</b>
                  <span className="tcs">{c.posClock}</span>
                  <span className={`wf-chip ${c.kind === 'selected' ? 'ok' : c.kind === 'unselected' ? 'warn' : 'todo'}`}>{c.label}</span>
                </button>
              ))}
            </div>
          </div>
        ))}
        <div className="wf-tl-sc" style={{ borderLeftColor: 'var(--line-2)' }}>
          <span className="wf-tl-lab">Hết tập</span>
          <div className="wf-tl-row"><div style={{ paddingTop: 40, fontFamily: 'var(--mono)', fontWeight: 600 }}>{t.endClock}</div></div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowAssemblyTimeline;
